import { CommonRootState } from '../combineReducers';
import { DeepReadonly } from 'utility-types';
import { IOrganization, OrganizationFeature } from '../interfaces/organization';

/**
 * True when the organization acts as an assignee (i.e. it is not a hiring Client). Extracted so the
 * To Do widget and the nav alerts bubble share a single definition and cannot drift apart.
 */
export const isAssigneeOrg = (organization: DeepReadonly<IOrganization> | null): boolean =>
  organization === null || !organization.features.includes(OrganizationFeature.Client);

export const selectIsAssigneeOrg = (state: CommonRootState): boolean => isAssigneeOrg(state.organization.organization);

/**
 * True when the organization is a CHAS contractor. Provided as a shared CHAS-exclusion gate for
 * US-only To Do items (consumed by later CPRO-11590 cards such as CPRO-14801 and CPRO-23766).
 */
export const selectIsChasContractor = (state: CommonRootState): boolean => {
  const { organization } = state.organization;
  return organization !== null && organization.features.includes(OrganizationFeature.ChasOrganizationFields);
};
